import React from "react";
import { PlayCircle } from "lucide-react";
import Button from "../../../../../components/ui/Button";

const CourseItem = ({ course }) => {
  return (
    <div className="bg-white p-4 rounded-xl border border-slate-200 flex items-center space-x-4">
      <div className="flex-shrink-0 w-12 h-12 rounded-lg flex items-center justify-center bg-primary/10 text-primary">
        <PlayCircle size={28} />
      </div>
      <div className="flex-grow">
        <p className="font-bold text-slate-800">{course.title}</p>
        <p className="text-sm text-slate-500">by {course.creatorName}</p>
      </div>
      <Button
        as="a"
        href={course.link}
        target="_blank"
        rel="noopener noreferrer"
        size="sm"
      >
        Start
      </Button>
    </div>
  );
};

export default CourseItem;
